import React from "react";

function MachinelogicAppIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="56" fill="none">
      <path
        fill="#197CE0"
        fillRule="evenodd"
        d="M1.29 11.965A1.29 1.29 0 000 13.255V53a3 3 0 003 3h54a3 3 0 003-3V13.256a1.29 1.29 0 00-1.29-1.29H1.29zm7.56 8.216a.86.86 0 00-.86.86v4.424c0 .475.385.86.86.86h27.148a.86.86 0 00.86-.86V21.04a.86.86 0 00-.86-.86H8.85zm-.86 23.903a.86.86 0 01.86-.86h15.261a.86.86 0 01.86.86v4.424a.86.86 0 01-.86.86H8.851a.86.86 0 01-.86-.86v-4.424zm45.527-9.404a.442.442 0 010 .703l-9.307 7.09a.442.442 0 01-.71-.353v-4.017H8.855a.86.86 0 01-.86-.86V32.82a.86.86 0 01.86-.86H43.5v-4.016c0-.366.42-.574.71-.352l9.308 7.089z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#a)"
        d="M0 4a4 4 0 014-4h52a4 4 0 014 4v10.013H0V4z"
      ></path>
      <ellipse cx="53.776" cy="7.869" fill="#fff" rx="2.83" ry="2.56"></ellipse>
      <defs>
        <linearGradient
          id="a"
          x1="30"
          x2="30"
          y1="1.724"
          y2="20.158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197CE0"></stop>
          <stop offset="1" stopColor="#243FA0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default MachinelogicAppIcon;

